export const ErrorBox = ({ children }) => {
  const className = `block text-red-600 text-sm flex items-center`;

  return <p className={className}>{children}</p>;
};
